import carBenefitsImage from "./assets/car-insurance-benefits.jpg";
import carHeroImage from "./assets/car-insurance-illustration.png";
import healthHeroImage from "./assets/health-insurance-illustration.png";
import homeHeroImage from "./assets/home-insurance-illustration.png";
import mascotImage from "./assets/meet-p-go-cat.jpg";
import aigCardLogo from "./assets/partners/AIG_02.jpg";
import gigLogo from "./assets/partners/GIG_04.png";
import livaLogo from "./assets/partners/Liva_03.png";
import rakInsuranceLogo from "./assets/partners/RAKInsurance_01.png";
import aurumInsuranceLogo from "./assets/publiclogos/aurum.png";
import aedSymbol from "./assets/partners/UAE_Dirham_Symbol.png";
import dniLogo from "./assets/partners/dni.jpg";
import livaPartnerLogo from "./assets/partners/liva.jpg";
import pciLogo from "./assets/partners/pci__1755783880000.png";
import qicLogo from "./assets/partners/qic.jpg";
import rakPartnerLogo from "./assets/partners/rak.jpg";
import salamaLogo from "./assets/partners/salama.jpg";
import visaLogo from "./assets/partners/visa__1755783880000.png";
import mastercardLogo from "./assets/partners/mastercard__1755783880000.png";
import quoteHowItWorksImage from "./assets/product-img1.jpg";
import saveTimeIcon from "./assets/save-time.png";
import documentSidebarMascot from "./assets/travel-insurance-banner-left-image1.png";
import travelBenefitsImage from "./assets/travel-benefits-img.jpg";
import travelHeroImage from "./assets/travel-insurance-illustration.png";
import uploadIllustration from "./assets/upload_file.png";
import whyChooseUsImage from "./assets/why-section.jpg";
import heroImage from "./assets/cat_mobile.png";
import sliderPrimarySecondaryCoverage from "./assets/sliders/Travel1PrimarySecondaryCoverage.png";
import sliderCancelForAnyReason from "./assets/sliders/Travel2CancelForAnyReason.png";
import sliderPreExistingWindow from "./assets/sliders/Travel3PreExistingWindow.png";
import whatappLogo from "./assets/publiclogos/whatsapp-icon.png";
import BrandLogo from "./assets/publiclogos/insurancehub.png";
import ChatRobot from "./assets/publiclogos/chatbot-icon.jpg";

export const whiteLabelResources = {
  App_Url: {
    public: {
      Whatsapp: whatappLogo,
      BrandLogo: BrandLogo,
      ChatBot: ChatRobot,
    },
    homePage: {
      HeroImage: heroImage,
      WhyChooseUsImage: whyChooseUsImage,
      MascotImage: mascotImage,
    },
    products: {
      CarImage: carHeroImage,
      HomeImage: homeHeroImage,
      TravelImage: travelHeroImage,
      HealthImage: healthHeroImage,
    },
    quoteFlow: {
      UploadIllustration: uploadIllustration,
      SaveTimeIcon: saveTimeIcon,
      DocumentSidebarMascot: documentSidebarMascot,
      TravelSliders: {
        PrimarySecondaryCoverage: sliderPrimarySecondaryCoverage,
        CancelForAnyReason: sliderCancelForAnyReason,
        PreExistingWindow: sliderPreExistingWindow,
      },
    },
    insurancePages: {
      car: {
        HeroImage: carHeroImage,
        HowItWorksImage: carBenefitsImage,
      },
      travel: {
        HeroImage: travelHeroImage,
        BenefitsImage: travelBenefitsImage,
        HowItWorksImage: quoteHowItWorksImage,
      },
    },
    partners: {
      carousel: {
        Rak: rakPartnerLogo,
        Qic: qicLogo,
        Dni: dniLogo,
        Salama: salamaLogo,
        Liva: livaPartnerLogo,
      },
      insurers: {
        RakInsurance: rakInsuranceLogo,
        AurumInsurance: aurumInsuranceLogo,
        Qic: qicLogo,
        Salama: salamaLogo,
        Liva: livaLogo,
        Aig: aigCardLogo,
        Gig: gigLogo,
        DniInsurance: dniLogo,
      },
      payments: {
        Mastercard: mastercardLogo,
        Visa: visaLogo,
        Pci: pciLogo,
      },
      symbols: {
        Aed: aedSymbol,
      },
    },
  },
} as const;
